import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { Faction } from '@/typings/faction';
import FactionEntry from '@/components/Faction/FactionEntry.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    factions: null,
    public: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.factions, (faction) => {
    return (_openBlock(), _createBlock(FactionEntry, {
      key: faction.Uuid,
      faction: faction
    }, null, 8, ["faction"]))
  }), 128))
}
}

})